/* unplugin-vue-components disabled */import { render } from "./personal_information.vue?vue&type=template&id=4c2c55f7&scoped=true"
import script from "./personal_information.vue?vue&type=script&lang=js"
export * from "./personal_information.vue?vue&type=script&lang=js"

import "./personal_information.vue?vue&type=style&index=0&id=4c2c55f7&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c2c55f7"]])

export default __exports__